import tw from 'twin.macro';
import styled from 'styled-components';

const Button = styled.button(
  ({ primary, secondary, bgPrimary, bgSecondary, className, disabled }) => [
    bgPrimary
      ? tw`bg-green-500 text-white bg-opacity-90 hover:bg-opacity-100`
      : ``,
    bgSecondary
      ? tw`bg-gray-400 text-white bg-opacity-90 hover:bg-opacity-100`
      : ``,
    primary ? tw` bg-white text-green-500 ` : ``,
    secondary ? tw` border-gray-400 bg-gray-100 text-gray-800` : ``,
    // whitespace-nowrap + shrink-0: buttons sit in flex filter rows, where they
    // would otherwise be squeezed and wrap their label onto a second line.
    tw`flex justify-center items-center gap-2 shadow-lg px-2 lg:px-4 py-1 lg:py-2 rounded-lg hover:scale-105 transition-all whitespace-nowrap flex-shrink-0`,
   
    !disabled
    ? tw`bg-green-500 text-white bg-opacity-90 hover:bg-opacity-100`
    : tw`bg-gray-400 text-white bg-opacity-90 hover:bg-opacity-100`,
  ]
);
export default Button;
